import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import styles from './carousel.module.css';
import { SparePartCard } from '../ui/sparePartCard/SparePartCard';


export function Carousel() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ dragFree: true });

  const mockData = [
    {
      img: '/images/air.jpg',
      text: 'Воздушные фильтры',
      link: "/car-filters/airfilter"
    },
    {
      img: '/images/oil.jpg',
      text: 'Масляные фильтры',
      link: "/car-filters/oilfilter"
    },
    {
      img: '/images/fuel.jpg',
      text: 'Топливные фильтры',
      link: "/car-filters/fuelfilter"
    },
    {
      img: '/images/salun.jpg',
      text: 'Салонные фильтры',
      link: "/car-filters/cabinfilter"
    },
    {
      img: '/images/akpp.JPG',
      text: 'АКПП фильтры',
      link: "/car-filters/transmissionfilter"
    },
  ];

  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const updateScrollStates = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    updateScrollStates();

    emblaApi.on('select', updateScrollStates);
    emblaApi.on('reInit', updateScrollStates);

    return () => {
      emblaApi.off('select', updateScrollStates);
      emblaApi.off('reInit', updateScrollStates);
    };
  }, [emblaApi, updateScrollStates]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <section className={styles.carousel_section}>
      <div className={styles.embla} ref={emblaRef}>
        <div className={styles.embla__container}>
          {mockData.map((item, id) => {
            return (
              <div key={id} className={styles.embla__slide}>
                {' '}
                <SparePartCard
                  text={item.text}
                  img={item.img}
                  width={'w-530'}
                  height={'h-345'}
                  link={item.link}
                />{' '}
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.embla__button__container}>

        <button
          className={`${styles.embla__button} ${styles.embla__button__left} ${canScrollPrev ? styles.active : ''
            }`}
          onClick={scrollPrev}
        ></button>
        <button
          className={`${styles.embla__button} ${styles.embla__button__right} ${canScrollNext ? styles.active : ''
            }`}
          onClick={scrollNext}
        ></button>
      </div>
    </section>
  );
}
